import { message, notification } from "antd";
import type { TypeOpen } from "antd/es/message/interface";

export const useMessage = () => {
  const [messageApi, contextHolder] = message.useMessage();

  const info: TypeOpen = (msg, duration) => {
    const result = messageApi.info(msg, duration);
    return result;
  };

  const error: TypeOpen = (msg, duration) => {
    const result = messageApi.error(msg, duration);
    return result;
  };

  const warning: TypeOpen = (msg, duration) => {
    const result = messageApi.warning(msg, duration);
    return result;
  };

  const loading: TypeOpen = (msg, duration) => {
    const result = messageApi.loading(msg, duration);
    return result;
  };

  const success: TypeOpen = (msg, duration) => {
    const result = messageApi.success(msg, duration);
    return result;
  };

  return {
    info,
    error,
    warning,
    loading,
    success,
    message: messageApi,
    contextHolder,
  };
};

interface NotificationConfig {
  message: string;
  description?: string;
}
export const useNotification = () => {
  const [api, contextHolder] = notification.useNotification();

  return { notification: api, contextHolder };
};
